var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgStepBackward(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 30 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { d: "M11.25 4.125v4.969L19.5 3.28c.234-.187.516-.281.797-.281a1.46 1.46 0 011.453 1.453v15.14A1.41 1.41 0 0120.344 21c-.328 0-.61-.047-.844-.234l-8.25-5.813v4.922A1.11 1.11 0 0110.125 21C9.469 21 9 20.531 9 19.875V4.125C9 3.515 9.469 3 10.125 3c.61 0 1.125.516 1.125 1.125zm0 8.11L19.5 18V6.047l-8.25 5.766v.421z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgStepBackward);
export default ForwardRef;
